module.exports = __webpack_public_path__ + "static/img/process.144fb75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/process.png
// module id = SW/g
// module chunks = 1